import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { useTranslationNamespace } from "@logex/framework/lg-localization";

import { Auth0AuthorizationService, Auth0User } from "@authorization";
import { createReturnUrlWithErrorCode } from "@app/util/return-url.util";

@Component({
    selector: "app-access-denied",
    templateUrl: "./access-denied.component.html",
    styleUrls: ["./access-denied.component.scss"],
    providers: [useTranslationNamespace("APP._AccessDenied")],
    standalone: false
})
export class AccessDeniedComponent implements OnInit {
    private _auth0Authorization = inject(Auth0AuthorizationService<Auth0User>);
    private _route = inject(ActivatedRoute);

    ngOnInit(): void {
        const returnUrl = this._route.snapshot.queryParamMap.get("returnUrl");
        if (returnUrl) {
            const targetUrl = createReturnUrlWithErrorCode(returnUrl, "access-denied");
            if (targetUrl) {
                window.location.assign(targetUrl);
            }
        }
    }

    _logout(): void {
        this._auth0Authorization.logout();
    }
}
